import * as React from 'react';

import Video, { VideoProps } from 'components/atoms/Video';
import Rich from 'components/molecules/Rich';
import Timer from 'components/molecules/Timer';

export type ContentVideoProps = {
	video: VideoProps;
	caption?: {
		title?: string;
		text?: string;
	};
	modifier?: string;
	slide?: number[];
	seconds?: number;
};

const ContentVideo = ({ video, caption, modifier, slide, seconds = 0 }: ContentVideoProps) => {
	return (
		<div className={`m-content-video${modifier ? ` m-content-video--${modifier}` : ''}`}>
			<div className="h-widen-16">
				{video && <Video code={video.code} ratio={video.ratio} />}
				{seconds > 0 && <Timer id={video.code} seconds={seconds} />}
			</div>
			{slide && slide.length > 0 && (
				<div className="m-content-video__meta">
					{slide[0]} / {slide[1]}
				</div>
			)}
			{caption && (
				<figcaption className="m-content-video__caption">
					{caption.title && <h6 className="m-content-video__title">{caption.title}</h6>}
					{caption.text && <Rich contents={caption.text} />}
				</figcaption>
			)}
		</div>
	);
};

export default ContentVideo;
